import React from 'react';
import Context from './context';

class Store extends React.Component {
  state = {
    pspResponseData: { qrCode: '' },
  };

  setPspResponseData = (data) => this.setState({ pspResponseData: data });

  render() {
    const { children } = this.props;
    const props = {
      ...this.state,
      setPspResponseData: this.setPspResponseData,
    };

    return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
  }
}

export default Store;
